<template>
  <div class="basic-reference-field">
    <div class="basic-reference-field__title">
      {{ $t(fieldName) }}
    </div>
    <div
      class="basic-reference-field__value basic-reference-field__background"
    >
      <s-number
        fallback-value="-"
        :value="fieldValue"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicReferenceField',
  props: {
    fieldName: {
      type: String,
      default: '',
    },
    fieldValue: {
      type: [String, Number],
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .basic-reference-field
    display: flex
    width: 100%
    flex-direction: row
    flex-wrap: nowrap
    align-items: center
    min-height: 2em
    padding: 0 5px
    margin: 5px 0
    &__title
      position: relative
      display: flex
      align-items: center
      justify-content: flex-end
      text-align: right
      width: 80%
      height: 95%
      font-size: 0.975em
      padding-right: 8px
      +media-max-sm
        word-break: break-word
    &__value
      position: relative
      color: $color-gray-intermediary
      height: 100%
      min-height: 28px
      width: 20%
      padding-right: 3px
      display: flex
      align-items: center
      justify-content: flex-end
      border-radius: 3px
      +media-max-sm
        word-break: break-word
    &__background
      background: var(--color-background-light)

  .manage-fonts_18px
    .basic-reference-field
      &__title
        width: 70%
      &__value
        width: 30%
</style>

